import { Link } from 'react-router-dom';
import { articles } from '@/mocks/animeData';

export default function ArticleSection() {
  return (
    <section className="bg-background-100 py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              动漫资讯
            </h2>
            <p className="text-sm text-foreground-500 mt-1">最新动漫资讯与深度解析</p>
          </div>
          <Link
            to="/category/riman"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            更多资讯 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {articles.slice(0, 4).map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={article.cover}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2 flex-wrap">
                  {article.tags.slice(0, 2).map((tag) => (
                    <span key={tag} className="px-2 py-0.5 rounded-md bg-accent-100 text-accent-700 text-xs whitespace-nowrap">
                      {tag}
                    </span>
                  ))}
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                  {article.summary}
                </p>
                <div className="flex items-center gap-3 mt-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-eye-line"></i>
                    {article.readCount.toLocaleString()} 阅读
                  </span>
                  <span className="whitespace-nowrap">{article.publishDate}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}